var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5422 1.04121C11.0714 1.55331 11.0852 2.39741 10.5731 2.92658L5.01883 8.66602H21.8731C22.6094 8.66602 23.2064 9.26297 23.2064 9.99935C23.2064 10.7357 22.6094 11.3327 21.8731 11.3327H5.01883L10.5731 17.0721C11.0852 17.6013 11.0714 18.4454 10.5422 18.9575C10.0131 19.4696 9.16895 19.4557 8.65685 18.9266L1.36358 11.3902C0.613184 10.6148 0.613182 9.38392 1.36358 8.60851L8.65685 1.07212C9.16895 0.542957 10.0131 0.52912 10.5422 1.04121Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowLeft);
export default __webpack_public_path__ + "static/media/ic_arrow-left.fa332cb6c1f3747f0f286d81a2e5744a.svg";
export { ForwardRef as ReactComponent };